import { mainUrl, client } from '../app-constants';

export function getPianoTechPianoList() {
    const url = mainUrl + 'pt.pianos/listPianoTechPiano'

    return client.get(url);
}

export function getPianoTechPianoListForCompany(companyId) {
    const url = mainUrl + 'pt.pianos/listByCompanyId?companyId=' + companyId;

    return client.get(url);
}

export function findPianoTechPiano(pianoId) {
    const url = mainUrl + 'pt.pianos/findPianoTechPiano?pianoId=' + pianoId;

    return client.get(url);
}

export function savePianoTechPiano(pianoTechPiano) {
    const url = mainUrl + 'pt.pianos/savePianoTechPiano';

    return client.post(url, pianoTechPiano);
}

